import React, { useRef, useState, useEffect } from 'react';
import {Toast} from 'antd-mobile';
import DfPrice from '@/components/dFPrice';
import {timeToHm, timeAdd} from '@/utils/time';
import {toPrice} from '@/utils/price';
import fudou from '@/assets/imgs/fudou.png';
import styles from './index.less';
import {greaterThanNow} from '@/utils/time';
import { getCookie, TLang } from '@/utils/lang';
import homeReq from '@/entity/module/home/homeAPi';
import { BFD_checkApp, BFD_LoginOut } from '@/utils/bfdApp';
import { gioClick } from '@/utils/gioApi';
const SessionItem =(props) => {
  const [sale, setSale] = useState(false);
  const divRef = useRef(null);
  useEffect(() => {
    if(props.endBuyTime){
      const s:boolean = greaterThanNow(props.endBuyTime);
      setSale(s);
    }else if(props.showDateTime){
      const s:boolean = greaterThanNow(props.showDateTime, 30);
      setSale(s);
    }
  }, []);
  const clickHandle=() => {
    if (props?.price2) {
      const s:boolean = greaterThanNow(props.endBuyTime2);
      if (s) {
        props.click&&props.click();
      } else {
        Toast.info(TLang('当前场次已过抢折扣时间，请重新购票。', 'home', false, false, null));
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } else {
      let s: boolean = true;
      if(props.endBuyTime){
        s = greaterThanNow(props.endBuyTime);
      }else if (props.showDateTime){
        s = greaterThanNow(props.showDateTime, 30);
      }
      if(s){
        const isBFDAPP = BFD_checkApp();
        if(isBFDAPP) {
          homeReq.getLoginStatus().then((res) => {
            if(res?.loginFlag===0){
              BFD_LoginOut();
            } else {
              props.click&&props.click();
            }
          });
        } else {
          props.click&&props.click();
        }
      } else {
        Toast.info(TLang('开场不足30分钟,已停止售票', 'home', false, false, null));
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    }
  };
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if(entry.isIntersecting) {
        checkExposureGio();
      }
    }, {
      root: null, // 默认是视口
      rootMargin: '0px',
      threshold: 0 // 触发的阈值，可以根据需求调整
    });
    if (divRef.current) {
      observer.observe(divRef.current);
    }
    return () => {
      if (divRef.current) {
        observer.unobserve(divRef.current);
      }
    };
  }, []);

  const checkExposureGio = () => {
    let sessionGio: any[] = JSON.parse(sessionStorage.getItem('film_movieList') || '[]') || [];
    // if (!sessionGio.includes(`movieList${props.index}`)) {
    //   // 更新当前的埋点曝光gioIng状态
    //   sessionGio.push(`movieList${props.index}`);
    //   sessionStorage.setItem('film_movieList', JSON.stringify(sessionGio));
      try {
        gioClick('电影-影院详情', {
          pagename: '影院详情',
          modulename: '影院详情列表',
          elementname: '购票',
          floorNum: 4,
          HPbanenrNum: props?.keyIndex + 1,
          JumpAddress: window.location.origin + '/movieSeat',
          channle: '电影',
          cinemaName: props?.cinemaName,
          name: props?.movieName,
          showDate: props?.showDate,
          showDateTime: props?.showDateTime,
          cinemaCode: props?.nationCode,
          price: props?.price / 100
        }, 'DF_exposureEvent');
      } catch (error) {
        console.error(error);
      }
    // } else {
    //   sessionGio = sessionGio.filter((item) => item != `movieList${props.index}`);
    //   sessionStorage.setItem('film_movieList', JSON.stringify(sessionGio));
    // }
  };

  return <div className={`${styles.itemContainer} ${props.noBorder?styles.noBorder:''}`}  id={`movieList${props.index}`}  ref={divRef} onClick={clickHandle}>
    <div className={styles.timewrapper}>
      <span>{`${timeToHm(props.showDateTime)}`}</span>
      <span>{`${timeAdd(props.showDateTime, props.duration)}${TLang('散场', 'home', false, false, null)}`}</span>
    </div>
    <div className={styles.infowrapper}>
      <span>{`${props.language}${props.dimensional}`}</span>
      <span>{`${props.hallName}`}</span>
    </div>
    <div className={styles.buyWrapper}>
      <div className={styles.priceWrapper}>
        {/* <span><img className={styles.fudou} src={fudou}/>{toPrice(props.price)}</span> */}
        {
          props?.price2 ? (
            <>
              {props?.price2Ratio ? <div className={styles.discountInfo}>{getCookie('df_lang') == 'en-US' ? ((1 - props?.price2Ratio) * 100).toFixed(0) + '%' : props?.price2Ratio * 100}{TLang('折', 'home', false, false, null)}</div> : null}
              <div>
                <DfPrice price={props.price2} iconCls={'xl'} textStyles={{'fontSize':'0.28rem', 'color':'#F44545', 'marginRight':'3px'}}/>
                <DfPrice price={props.price} lineThroungh iconCls={'xl'} textStyles={{'fontSize':'0.24rem', 'color':'#999',  'fontWeight':300, 'textDecoration': 'line-through', 'marginRight':'3px'}}/>
              </div>
            </>
          ) : (
            <DfPrice price={props.price} iconCls={'xl'} textStyles={{'fontSize':'0.32rem', 'color':'#F44545', 'marginRight':'3px'}}/>
          )
        }
        {
          props.marketPrice>props.price?
          // <span>{toPrice(props.marketPrice)}</span>
            <DfPrice showIcon={false} price={props.marketPrice} textStyles={{'fontSize':'0.24rem', 'color':'#999', 'textDecoration': 'line-through', 'fontWeight':300, 'marginRight':'3px'}}/>
          :null
        }

      </div>
      {
        sale?
        (
          props?.price2 ? (
            <div className={`${styles.buy} ${props?.price2 ? styles.buyPrice : ''}`}>
              {TLang('抢票', 'home', false, false, null)}
            </div>
          ) : (
            <div className={`${styles.buy} ${props?.price2 ? styles.buyPrice : ''}`}>
              {TLang('购买', 'home', false, false, null)}
            </div>
          )
        )
        :
            <div className={styles.nobuy}>{TLang('停售', 'home', false, false, null)}</div>

      }
    </div>
  </div>;
};
export default SessionItem;
